module.exports = __webpack_public_path__ + "cd455783/img/boston-lights.a623432f.png";